import { InputMultiSelectControl, MultiSelect } from '../../Select'
import { UserInfoStatusSelect } from '../UserInfoStatusSelect'

import { USER_INFO_STATUS_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG } from './UserInfoStatusMultiSelect.constants'

function UserInfoStatusMultiSelect({
  Control = InputMultiSelectControl,
  dropdownFloatingConfig = USER_INFO_STATUS_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      Select={UserInfoStatusSelect}
      dropdownFloatingConfig={dropdownFloatingConfig}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default UserInfoStatusMultiSelect
